import React from 'react'
import { Line } from 'react-chartjs-2';

function LineChart({stats, wanted_data}) {

    let datasets = []
    let colors = ['#155ba3', '#aec7e8', '#ff7f0e', '#ffbb78', '#70bf70'];
    

     Object.keys(wanted_data).forEach((key, index) => {
        if(key !== 'date') {
        datasets.push({
            label: wanted_data[key],
            data: stats[key],
            fill: false,
            backgroundColor: colors[index],
            borderColor:  colors[index],
            borderWidth: 2
        })
        }
    })
     const data = {
        labels: stats.date,
        datasets: datasets
    };
    

    const options = {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
            x: {
                ticks: {
                    maxTicksLimit: 5,
                    font: {
                        size: window.innerWidth > 540 ? 14 : 10
                    }
                }
            },
            y: {
                min: 0,
                ticks: {
                    font: {
                        size: window.innerWidth > 540 ? 14 : 10
                    }
                }
            }
        },
        elements: {
            point: {
                radius: 0
            }
        },
        plugins: {
            legend: {
                align: 'center',
                labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                    boxWidth:  window.innerWidth > 540 ? 8 : 3,
                    
                    font: {
                        size: window.innerWidth > 540 ? 16 : 10,

                    },
                },
                onHover: function (e) {
                    e.native.target.style.cursor = 'pointer'
                },
            },
        },
        tooltips: {
            mode: 'nearest',
            intersect: false,
        },
        hover: {
            mode: 'nearest',
            intersect: false
        },
        onHover: function (e) {
            e.native.target.style.cursor = 'pointer'
        },

    }

  return (
    <Line data={data} options={options} className="linechart"/>
  )
}

export default LineChart